import invoiceLabels from "emun.invoice/_labels";

export default {
  Id: "Id: Low to High",
  "-Id": "Id: High to Low",
  "OrderNumber,-Id": "Order #: Low to High",
  "-OrderNumber,-Id": "Order #: High to Low",
  "OrderNumber,-Id": "Order #: Low to High",
  "-OrderNumber,-Id": "Order #: High to Low",
  "Status,-Id": "Status: A to Z",
  "-Status,-Id": "Status: Z to A",
  ...(invoiceLabels.tagFor
    ? {
        "TagFor,-Id": invoiceLabels.tagFor,
        "-TagFor,-Id": invoiceLabels.tagFor,
      }
    : {}),
  "Division,-Id": "Division: A to Z",
  "-Division,-Id": "Division: Z to A",
  "CompanyName,-Id": "Name: A to Z",
  "-CompanyName,-Id": "Name: Z to A",
  "InvoiceDate,-Id": "Invoice Date: Newest",
  "-InvoiceDate,-Id": "Invoice Date: Oldest",
  "InvoiceTotal,-Id": "Amount: Low to High",
  "-InvoiceTotal,-Id": "Amount: High to Low",
  "CreditMemoTotal,InvoiceTotal,-Id": "Invoice Total: Low to High",
  "-CreditMemoTotal,InvoiceTotal,-Id": "Invoice Total: High to Low",
};
